import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFallContrastIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 3H2C1.45 3 1 3.45 1 4V20C1 20.55 1.45 21 2 21C2.55 21 3 20.55 3 20V5H21V20C21 20.55 21.45 21 22 21C22.55 21 23 20.55 23 20V4C23 3.45 22.55 3 22 3Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFallContrastIcon.displayName = 'TsplatFallContrastIcon';
